import { render, staticRenderFns } from "./OptionConfig.vue?vue&type=template&id=3662b132&scoped=true"
import script from "./OptionConfig.vue?vue&type=script&lang=js"
export * from "./OptionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662b132",
  null
  
)

export default component.exports